import styled from 'styled-components'

import CreateCityPlanFormUnstyled from 'Containers/Form/Campaigns/CreateCityPlan/unstyled'

export const CreateCityPlanForm = styled(CreateCityPlanFormUnstyled)`
  .section-wrapper {
    padding: 40px;
    margin: 0 0 30px 0;

    .row {
      input {
        width: 154px;
      }

      input[type='checkbox'] {
        width: inherit;
      }

      .select-wrapper {
        width: 154px;
      }
    }

    .row:not(:last-child) {
      margin-top: 25px;
      margin-bottom: 30px;
    }
  }

  .submit-button {
    float: right;

    input {
      width: auto;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/Campaigns/CreateCityPlan/index.js